import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EmailPreviewFrame } from "./EmailPreviewFrame";

/** Every client-facing template rendered with labelled SAMPLE data for design approval. */
export const DesignGallery = () => {
  const [g, setG] = useState(null);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/comms/design/gallery").then(({ data }) => { setG(data); setSel(data.items[0]?.id || null); }).catch(() => {}); }, []);
  if (!g) return <div className="text-sm text-slate-400 p-4">Rendering gallery…</div>;
  const cur = g.items.find((i) => i.id === sel);
  return (
    <div className="grid lg:grid-cols-[280px_1fr] gap-4" data-testid="design-gallery">
      <div className="space-y-2">
        <div className="text-[11px] text-slate-500 border border-slate-200 rounded-md px-3 py-2 bg-white">
          {g.sample_note}<br />{g.issuer || "SUNTRONIX"} templates send as <span className="font-medium text-slate-800">{g.from}</span> · Reply-To <span className="font-medium text-slate-800">{g.reply_to}</span>
        </div>
        {["CRM / milestone", "Code-built", "Deployment case"].map((grp) => (
          <div key={grp}>
            <div className="text-[10px] uppercase tracking-wide text-slate-400 px-1 mt-2 mb-1">{grp}</div>
            {g.items.filter((i) => i.group === grp).map((i) => (
              <button key={i.id} type="button" onClick={() => setSel(i.id)} data-testid={`gallery-item-${i.id}`}
                className={`w-full text-left px-3 py-1.5 rounded text-[12px] border mb-1 ${sel === i.id ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 hover:border-slate-400"}`}>
                <div className="font-medium truncate">{i.name}</div>
                <div className={`truncate text-[10px] ${sel === i.id ? "text-slate-300" : "text-slate-400"}`}>{i.subject}</div>
                {i.unresolved?.length > 0 && <div className="text-[10px] text-rose-500">unresolved: {i.unresolved.join(", ")}</div>}
              </button>
            ))}
          </div>
        ))}
        {g.logo_note && <div className="text-[11px] text-slate-600 border border-slate-200 rounded-md px-3 py-2 bg-white" data-testid="gallery-logo-note">{g.logo_note}</div>}
        <div className="text-[11px] text-amber-800 border border-amber-200 rounded-md px-3 py-2 bg-amber-50" data-testid="gallery-limitations">
          <div className="font-medium mb-1">Verification limits</div>
          <ul className="list-disc pl-4 space-y-0.5">{g.limitations.map((l) => <li key={l}>{l}</li>)}</ul>
        </div>
      </div>
      <div>
        {cur && (
          <>
            <div className="text-[12px] mb-2 border border-slate-200 rounded-md px-3 py-2 bg-white">
              <div><span className="text-slate-500">Subject:</span> <span className="font-medium" data-testid="gallery-subject">{cur.subject}</span></div>
              <div className="text-slate-400">{cur.group} · {cur.id} · {cur.version === "code" ? "code-built" : `v${cur.version}`} · {cur.active ? "active" : "inactive"} · sample data</div>
            </div>
            <EmailPreviewFrame html={cur.html} text={cur.text} height={640} testid="gallery-preview" />
          </>
        )}
      </div>
    </div>
  );
};
